<template>
  <div class="home-page">
    <van-tabbar  route v-model="active">
      <van-tabbar-item  to="/home/extension"><img class="bottom-banner" src="//qn.xwyyjt.com/ht_banner_index.png" alt=""></van-tabbar-item>
      <van-tabbar-item  to="/home/huawu"><div style="font-size:.24rem">话务管理</div> </van-tabbar-item>
      <van-tabbar-item  to="/home/my"><img class="bottom-banner"  src="//qn.xwyyjt.com/ht_banner_my.png" alt=""></van-tabbar-item>
    </van-tabbar>
    <router-view />
  </div>
</template>
<script>
  export default {
    name: "home",
    data() {
      return {
        active:0
      }
    }
  }
</script>

<style lang="scss">
  .home-page {
    .van-tabbar {
      height: 1rem;
      background: #0200FD;
    }
    .van-tabbar-item {
      color: #ffffff!important;

    }
  }
  .bottom-banner{
    width: .92rem;
    height: auto;
  }
  .van-cell__value {
    overflow: initial;
  }
  .van-tabbar--fixed {
    width: 7.5rem;
    margin: 0 auto;
    left: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue